// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import isConfirmationModalVisible from './confirmation-modal';
import isSubmitDisabled from './is-submit-disabled';
import laborRate from './labor-rate';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    isConfirmationModalVisible,
    isSubmitDisabled,
    laborRate
});



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/reducers/index.js